// extracted by css-extract-rspack-plugin
export default {"root":"cBfJ_f"};